var _style, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLiveStatsGray(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 138.8 138.8",
    style: {
      enableBackground: "new 0 0 138.8 138.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#56575A;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M69.4,0C31,0,0,31,0,69.4c0,38.4,31,69.4,69.4,69.4c38.4,0,69.4-31,69.4-69.4C138.8,31,107.7,0,69.4,0z  M69.4,127.9c-32.4,0-58.5-26.2-58.5-58.5C10.8,37,37,10.8,69.4,10.8c32.4,0,58.5,26.2,58.5,58.5 C127.9,101.7,101.8,127.9,69.4,127.9z M118.2,54.9v20.6c0,3-2.4,5.4-5.4,5.4c-3,0-5.4-2.4-5.4-5.4V68L87.7,87.7 c-2.1,2.1-5.6,2.1-7.7,0L54.9,62.6L29.9,87.7c-2.1,2.1-5.5,2.1-7.7,0c-2.1-2.1-2.1-5.6,0-7.7l28.9-28.9c2.1-2.1,5.5-2.1,7.7,0 l25.1,25.1l15.8-15.8h-7.5c-3,0-5.4-2.4-5.4-5.4c0-3,2.4-5.4,5.4-5.4h20.6C115.8,49.5,118.2,52,118.2,54.9z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiveStatsGray);
export default __webpack_public_path__ + "static/media/live_stats_gray.3ade414767abe34f8892110832d1bc33.svg";
export { ForwardRef as ReactComponent };